import React from 'react';
import '../css/components/badge.css'

/** Statuses that map to a green "success" badge */
const SUCCESS_STATUSES = [
  'Approved', 'Approved-Adjusted',
  'Active', 'Active-Adjusted',
  'Completed', 'Completed-Adjusted',
  'Manual-Payment',
] as const;

/** Statuses that map to a yellow "warning" badge */
const WARNING_STATUSES = [
  'Processing-ACH-Payment', 'Processing-ACH-Payment-Adjusted',
  'Processing-ACH-Refund-Adjusted', 'Pending', 'Pending-Verification Required', 'Incomplete',
] as const;

function getStatusClass(status: string): string {
  if ((SUCCESS_STATUSES as readonly string[]).includes(status)) {
    return 'ss-small ss-success-box';
  } else if ((WARNING_STATUSES as readonly string[]).includes(status)) {
    return 'ss-small ss-warning-box';
  } else {
    return 'ss-small ss-danger-box';
  }
}

interface StatusBadgeProps {
  children?: React.ReactNode;
  /** Vertically centers the text within the badge (replaces the legacy top-padding offset) */
  centered?: boolean;
}

/**
 * Renders a colored badge based on the booking/invoice status string
 * passed as children. Green for approved/active/completed, yellow for
 * processing/pending, red for everything else.
 */
function StatusBadge({ children, centered = false }: StatusBadgeProps) {
  const className = getStatusClass(String(children ?? ''));
  return (
    <div className={centered ? `${className} ss-badge-centered` : className}>{children}</div>
  );
}

export default StatusBadge;
